import { EPostFormFieldName } from '../../types/postForm';

export enum EPostFormActionType {
  Loading = 'postForm/loading',
  Succeed = 'postForm/succeed',
  Failed = 'postForm/failed',
  Reset = 'postForm/reset',
  SetField = 'postForm/setField',
}

export interface IPostFormLoading {
  type: EPostFormActionType.Loading;
}

export interface IPostFormSucceed {
  type: EPostFormActionType.Succeed;
  payload: {};
}

export interface IPostFormFailed {
  type: EPostFormActionType.Failed;
}

export interface IPostFormReset {
  type: EPostFormActionType.Reset;
}

export interface IPostFormSetField<FieldValue = any> {
  type: EPostFormActionType.SetField;
  payload: {
    fieldName: EPostFormFieldName;
    value: FieldValue;
  };
}

export type TPostFormActions =
  | IPostFormLoading
  | IPostFormSucceed
  | IPostFormFailed
  | IPostFormReset
  | IPostFormSetField;
